import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}
  permissao: boolean = false;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    if (next.queryParams && next.queryParams['code'] || state.url.includes('code=')) {
      return true;
    }

    this.auth.temQualquerPermissao(next.data.roles).then(hasPermission => {
      this.permissao = hasPermission;
    });

    if (this.auth.isAccessTokenInvalido()) {

      return this.auth.obterNovoAccessToken()
        .then(() => {
          if (this.auth.isAccessTokenInvalido()) {
            this.router.navigate(['/login']);
            return false;
          }

          return true;
        });
    } 
    else if (next.data.roles && !this.permissao) {
      this.router.navigate(['/not-found']);
      return false;
    }

    return true;
  }

}
